import React, { useState, useEffect, useRef } from 'react';
/*Hooks*/
import { useMediaQuery } from 'react-responsive';

import { useSelector, dispatch, useDispatch } from 'react-redux';

/*Components*/
import { styled, Container, Box, useTheme } from '@mui/material';
import Header from './components/vertical/header/Header';
import Footer from './components/vertical/footer';
import Sidebar from './components/vertical/sidebar/Sidebar';
import Customizer from './components/shared/customizer/Customizer';
import ErrorBoundary from '@components/ErrorBoundary';
import Impersonation from './components/impersonation';
import TestingMode from './components/testing';
import DeleteEvent from '@src/views/DeleteEvent';

/*Selectors*/
import { getUserData } from '@store/user/selector';
import { onCheckTestEvent } from '@store/common/actions';

/*Actions*/
import { onGetProfileUser } from '@store/user/actions';

/*Services*/
import { checkEventDelete } from '@store/common/services';

/*Constants*/
import { RETCODE_SUCCESS } from '@configs/contants';
import { useLocation } from 'react-router-dom';

const MainWrapper = styled('div')(() => ({
  display: 'flex',
  minHeight: '100vh',
  width: '100%',
  overflowX: 'hidden',
}));

const PageWrapper = styled('div')(() => ({
  display: 'flex',
  flexGrow: 1,
  paddingBottom: '24px',
  flexDirection: 'column',
  zIndex: 1,
  width: '100%',
  backgroundColor: 'transparent',
}));

const eventId = localStorage.getItem('eventId');

const FullLayout = ({ children, ...rest }) => {
  const dispatch = useDispatch();
  const customizer = useSelector((state) => state.customizer);
  const userData = useSelector(getUserData);

  const [isDelete, setIsDelete] = useState(false);

  const isDesktop = useMediaQuery({ minWidth: 1200 });

  const checkPage = useLocation();

  const refCustomizer = useRef();

  const theme = useTheme();

  useEffect(() => {
    if (!!userData?.eventId || !!eventId) {
      handleCheckTestEvent(userData?.eventId ?? eventId);
      onCheckDeleteEventId();
    }
  }, [eventId, JSON.stringify(userData)]);

  useEffect(() => {
    onInitProfile();
  }, [JSON.stringify(userData)]);

  const onCheckDeleteEventId = async () => {
    try {
      const res = await checkEventDelete(userData?.eventId ?? eventId);
      if (res?.retCode !== RETCODE_SUCCESS) {
        setIsDelete(res?.data === 'False' ? true : false);
        return;
      }
      setIsDelete(res?.data === 'False' ? true : false);
    } catch (e) {
      console.log('Error'), e;
    }
  };

  const handleCheckTestEvent = (eId) => {
    dispatch(onCheckTestEvent(eId));
  };

  const onInitProfile = async () => {
    if (!!userData?.userId) {
      dispatch(onGetProfileUser(userData?.userId));
    }
  };

  const toogleDrawer = () => {
    console.log('toogle', refCustomizer.current);
    if (refCustomizer.current && typeof refCustomizer.current.toogleDrawer === 'function') {
      refCustomizer.current?.toogleDrawer();
    }
  };

  return (
    <ErrorBoundary>
      {isDelete ? (
        <DeleteEvent />
      ) : (
        <MainWrapper
          className={customizer?.activeMode === 'dark' ? 'darkbg mainwrapper' : 'mainwrapper'}
        >
          <Sidebar toogleDrawer={toogleDrawer} />
          <PageWrapper
            className="page-wrapper"
            sx={{
              paddingBottom: checkPage.pathname.includes('thiep-cuoi') && '0 !important',
              ...(customizer?.isCollapse && {
                [theme?.breakpoints?.up('lg')]: {
                  ml: `${customizer?.MiniSidebarWidth}px`,
                },
              }),
            }}
          >
            <Header Impersonation={Impersonation} TestingMode={TestingMode} />
            <Container
              sx={{
                marginRight: 'unset',
                padding: checkPage.pathname.includes('thiep-cuoi')
                  ? '0 !important'
                  : '0 12px !important',
                maxWidth: !checkPage.pathname.includes('thiep-cuoi')
                  ? customizer?.isLayout === 'boxed' && isDesktop
                    ? customizer.isCollapse && !customizer.isSidebarHover
                      ? `calc(100vw - ${customizer.MiniSidebarWidth}px) !important`
                      : `calc(100vw - ${customizer.SidebarWidth}px)  !important`
                    : '100%!important'
                  : customizer?.isLayout === 'boxed' && isDesktop
                  ? `calc(100vw - ${customizer.MiniSidebarWidth}px) !important`
                  : '100%!important',
              }}
            >
              <Box sx={{ minHeight: 'calc(100vh - 170px)' }}>{children}</Box>
            </Container>
            {!checkPage.pathname.includes('thiep-cuoi') && <Footer />}
            <Customizer ref={refCustomizer} />
          </PageWrapper>
        </MainWrapper>
      )}
    </ErrorBoundary>
  );
};

export default FullLayout;
